export const getToken = () => {
    return localStorage.getItem("token");
  };

  export const getURL = () => {
    return "https://asia-south1-swifttransit-a32f8.cloudfunctions.net/api/";
  };